module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/logo-5d39cf39e867b6477b7e25233c6473ac.png";